export default [
  {
    id: 3,
    title: { it: "Librerie", en: "Bookcases" },
    subTitle: {
      it: "librerie a terra",
      en: "floorstanding bookcases",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/03a.jpg"),
        detailImage: "LibATerraHome",
        room: "Home",
        code: "03a",
        name: { it: "Ingresso", en: "Entrance" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/06c.jpg"),

        detailImage: "LibATerraHome",
        room: "Home",
        code: "06c",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/07b.jpg"),

        detailImage: "LibATerraHome",
        room: "Home",
        code: "07b",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/16b.jpg"),

        detailImage: "LibATerraHome",
        room: "Home",
        code: "16b",
        name: { it: "Garage", en: "Garage" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/01b.jpg"),

        detailImage: "LibATerraPublic",
        room: "Public",
        code: "01b",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/02c.jpg"),

        detailImage: "LibATerraPublic",
        room: "Public",
        code: "02c",
        name: { it: "Direzionale", en: "Executive space" },

        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/08c.jpg"),

        detailImage: "LibATerraPublic",
        room: "Public",
        code: "08c",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/11c.jpg"),

        detailImage: "LibATerraPublic",
        room: "Public",
        code: "11c",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height:
            "38,3 - 56,6 - 74,9 - 111,5 - 148,1 - 203 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "30 - 45 - 60 - 90 - 120",
          depths: "35,4 - 45,4",
        },
      },
    ],
  },
  {
    id: 4,
    title: { it: "Librerie", en: "Bookcases" },
    subTitle: { it: "librerie sospese", en: "wall-mounted bookcases" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/04a.jpg"),
        detailImage: "LibSospeseHome",
        room: "Home",
        code: "04a",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/10c.jpg"),

        detailImage: "LibSospeseHome",
        room: "Home",
        code: "10c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/12c.jpg"),

        detailImage: "LibSospeseHome",
        room: "Home",
        code: "12c",
        name: { it: "Lavanderia", en: "Laundry" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/18a.jpg"),

        detailImage: "LibSospeseHome",
        room: "Home",
        code: "18a",
        name: { it: "Disimpegno", en: "Vestibule" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/02b.jpg"),

        detailImage: "LibSospesePublic",
        room: "Public",
        code: "02b",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/05b.jpg"),

        detailImage: "LibSospesePublic",
        room: "Public",
        code: "05b",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/09a.jpg"),

        detailImage: "LibSospesePublic",
        room: "Public",
        code: "09a",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/15a.jpg"),

        detailImage: "LibSospesePublic",
        room: "Public",
        code: "15a",
        name: { it: "Negozio", en: "Store" },
        size: {
          heightsText: {
            it: "altezze con cappello",
            en: "heights with top cover",
          },
          height: "138,1 - 56,4 - 74,7 - 111,3 - 147,9 - 184,5",
          heightsText1: {
            it: "altezze con top intero",
            en: "heights with one-piece top",
          },
          height1: "37,6 - 55,9 - 74,2 - 110,8",
          widths: "37,6 - 55,9 - 74,2 - 110,8",
          depths: "35,4",
        },
      },
    ],
  },
  {
    id: 2,
    title: { it: "Librerie", en: "Bookcases" },
    subTitle: { it: "librerie sovrapposte", en: "sit-on-top bookcases" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/03c.jpg"),
        detailImage: "LibSovrapposte",
        room: "Home",
        code: "03c",
        name: { it: "Ingresso", en: "Entrance" },
        size: {
          heightsText: {
            it: "altezze per top 1,2 cm",
            en: "heights for 1.2 cm top",
          },
          height:
            "126,9 - 145,2 - 163,5 - 181,8 - 200,1 - 218,4 - 236,7 - 255 - 273,3",
          heightsText1: {
            it: "altezze per top 3 cm",
            en: "heights for 3 cm top",
          },
          height1:
            "125,1 - 143,4 - 161,7 - 180 - 198,3 - 216,6 - 234,9 - 253,2 - 271,5",
          widths: "30 - 45 - 60 - 90 -120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05d.jpg"),

        detailImage: "LibSovrapposte",
        room: "Home",
        code: "05d",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          heightsText: {
            it: "altezze per top 1,2 cm",
            en: "heights for 1.2 cm top",
          },
          height:
            "126,9 - 145,2 - 163,5 - 181,8 - 200,1 - 218,4 - 236,7 - 255 - 273,3",
          heightsText1: {
            it: "altezze per top 3 cm",
            en: "heights for 3 cm top",
          },
          height1:
            "125,1 - 143,4 - 161,7 - 180 - 198,3 - 216,6 - 234,9 - 253,2 - 271,5",
          widths: "30 - 45 - 60 - 90 -120",
          depths: "35,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/15c.jpg"),

        detailImage: "LibSovrapposte",
        room: "Home",
        code: "15c",
        name: { it: "Dispensa", en: "Pantry" },
        size: {
          heightsText: {
            it: "altezze per top 1,2 cm",
            en: "heights for 1.2 cm top",
          },
          height:
            "126,9 - 145,2 - 163,5 - 181,8 - 200,1 - 218,4 - 236,7 - 255 - 273,3",
          heightsText1: {
            it: "altezze per top 3 cm",
            en: "heights for 3 cm top",
          },
          height1:
            "125,1 - 143,4 - 161,7 - 180 - 198,3 - 216,6 - 234,9 - 253,2 - 271,5",
          widths: "30 - 45 - 60 - 90 -120",
          depths: "35,4",
        },
      },
    ],
  },
  {
    id: 1,
    title: { it: "Librerie", en: "Bookcases" },
    subTitle: { it: "librerie ponte", en: "bringing bookcases" },
    products: [
      {
        sourceImage: require("./images/mainImgs/public/06c.jpg"),

        detailImage: "LibPonte",
        room: "Public",
        code: "06c",
        name: { it: "Open space", en: "Open-plan layout" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "150 - 180 - 210",
          depths: "35,4 - 45,4",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/16a.jpg"),

        detailImage: "LibPonte",
        room: "Public",
        code: "16a",
        name: { it: "Negozio", en: "Store" },
        size: {
          height: "221,3 - 239,6 - 257,9 - 294,5",
          widths: "150 - 180 - 210",
          depths: "35,4 - 45,4",
        },
      },
    ],
  },
];
